import { render, staticRenderFns } from "./CDNTable.vue?vue&type=template&id=34a19f62&scoped=true&"
import script from "./CDNTable.vue?vue&type=script&lang=js&"
export * from "./CDNTable.vue?vue&type=script&lang=js&"
import style0 from "./CDNTable.vue?vue&type=style&index=0&id=34a19f62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a19f62",
  null
  
)

export default component.exports